<template>
  <div v-if="!!user" class="loginContainerRegister">
    <h2> Registrierung </h2>
    <fieldset class="registerGrid">
      <label for="registrierung_username">Nutzername*:</label>
      <FormField :attribute="user.$$.USERNAME" id="registrierung_username"/>
      <label for="registrierung_password">Passwort*:</label>
      <input type="password" v-model="passwort" id="registrierung_password"/>
      <label for="registrierung_password_confirm">Passwort wiederholen*:</label>
      <input type="password" v-model="passwortRepeat" id="registrierung_password_confirm"/>
      <label for="registrierung_nachname">Nachname*:</label>
      <FormField :attribute="user.$$.NACHNAME" id="registrierung_nachname"/>
      <label for="registrierung_vorname">Vorname*:</label>
      <FormField :attribute="user.$$.VORNAME" id="registrierung_vorname"/>
      <label for="registrierung_email">E-Mail-Adresse*:</label>
      <FormField :attribute="user.$$.EMAIL" id="registrierung_email"/>
      <label for="registrierung_telefon">Telefonnummer*:</label>
      <FormField :attribute="user.$$.TELEFON" id="registrierung_telefon"/>
      <label for="registrierung_funktion">Funktion*:</label> 
      <FormField :attribute="user.$$.FUNKTION" id="registrierung_funktion"/>
      <div style="grid-column: span 2;">        
        <input class="checkboxTextsize" type="checkbox" v-model="datenschutzerklaerung" id="registrierung_datenschutz"/> 
        <label for="registrierung_datenschutz">&nbsp;Ich habe die Datenschutzerklärung gelesen und erkenne die Inhalte an.</label> 
        
        <ModalWindowButton :hasCloseButton="true" :closeOnClickOut="true" width="500px" heading="Einwilligungserklärung in die Erhebung und Verarbeitung von Daten für die Fachanwendungen der Wasserwirtschaftsverwaltung in Rheinland-Pfalz">
          <template #buttonText>
            <span class="icon-round icon-round-para"> </span>
          </template>
          <template #modalWindowContent>
            <div id="MIP_Login_DSGVO">
              Die Datenschutzerklärung für Fachanwendungen der Wasserwirtschaftsverwaltung Rheinland-Pfalz wurde aktualisiert. 
              Hierbei wurden Änderungen vorgenommen, die die zum 25. Mai 2018 in Kraft getretenen Vorgaben der 
              EU-Datenschutzgrundverordnung (EU-DSVGO) berücksichtigen.
              <p class="MIP_AbstandOben-2">Im Folgenden klären wir über die Verwendung personenbezogener Daten registrierter Anwender in 
                  einer wasserwirtschaftlichen Fachanwendung auf. Die vollständige Datenschutzerklärung finden Sie auf dieser Webseite unter 
                  <a style="cursor:pointer; text-decoration:underline" title="Datenschutzerklärung" href="https://wasserportal.rlp-umwelt.de/servlet/is/1282/" target="_blank">Datenschutzerklärung</a>.</p>
              <p class="MIP_AbstandOben-2">Für diese Fachanwendung werden von registrierten Anwendern die folgenden personenbezogenen 
                  Daten erhoben und verarbeitet:</p>
              <ul style="list-style:disc;padding-left: 20px;">
                <li>Vor -und Nachname, postalische Adresse, Funktion</li>
                <li>Telefonnummer, E-Mail-Adresse</li>
                <li>institutionelle Zuordnung, zum Beispiel zu Verwaltungseinheit, Maßnahmeträger, Abgabe-oder Entgeltpflichtiger</li>
              </ul>
              Die Daten werden auf den Servern der Wasserwirtschaftsverwaltung Rheinland-Pfalz gespeichert und können nur von berechtigten 
              Personen eingesehen werden. Der Umfang der zum Anwender gespeicherten Daten kann von diesem jederzeit eingesehen und korrigiert werden.
              <p class="MIP_AbstandOben-2">Die in diesem Zusammenhang durchgeführte elektronische Verarbeitung der genannten Daten erfolgt 
                  auf der Grundlage geltender Gesetze und ist für den sachgerechten Betrieb der Fachanwendung notwendig.</p>
              <p class="MIP_AbstandOben-2">Durch <strong>Zustimmung zu dieser Einwilligungserklärung</strong> erklärt sich der Anwender mit der Erhebung, 
                  Speicherung und Verarbeitung dieser Daten im Zusammenhang mit dem Betrieb der Fachanwendung einverstanden.</p> 
              <p class="MIP_AbstandOben-2">Der Anwender hat das Recht, dieser Einwilligungserklärung nicht zuzustimmen oder diese Einwilligung 
                  jederzeit ohne Angabe einer Begründung zu widerrufen und die gespeicherten Daten löschen zu lassen. Da die Fachanwendung 
                  jedoch auf die Erhebung und Verarbeitung genannter Daten angewiesen ist, würde dies eine Inanspruchnahme der Fachanwendung 
                  ausschließen.</p>
              <p class="MIP_AbstandOben-2">Anfragen und andere Anliegen in diesem Zusammenhang sind per E-Mail an 
                  <a href="mailto:datascout@wwv.rlp.de">datascout@wwv.rlp.de</a> zu richten.</p>
            </div>
          </template>
        </ModalWindowButton>
      </div>
    </fieldset>
    
    <fieldset class="MIP_AbstandOben-3">
      <legend>Zuwendungsempfänger</legend>
      <p> 
        Bitte wählen Sie einen oder mehrere bereits registrierte Zuwendungsempfänger oder erstellen Sie einen neuen Zuwendungsempfänger. 
      </p>
      <p style="margin-top: 5px">Privatpersonen registrieren sich bitte mit ihrer Privatadresse als neuer Zuwendungsempfänger.</p>
      <div class="MIP_AbstandOben-2">
        <input class="checkboxTextsize" type="checkbox" id="registerAtExistingMt" v-model="registerAtExistingMt"/> 
        <label for="registerAtExistingMt">&nbsp;Ich möchte mich für einen bereits registrierten Zuwendungsempfänger eintragen.</label>
      </div>
      <div v-if="registerAtExistingMt" class="MIP_AbstandOben-2 MIP_AbstandUnten-3" style="padding-left: 20px">
        <div>
          Zuwendungsempfänger*:
          <ModalWindowButton :hasCloseButton="true" :closeOnClickOut="true" width="500px" heading="Zuwendungsempfänger">
            <template #buttonText>
              <span class="icon-round icon-round-info"> </span>
            </template>
            <template #modalWindowContent>
              <div>
                  Suchen Sie in der Liste der bereits registrierten Zuwendungsempfänger, indem Sie einen Suchtext eingeben. Die Liste wird gefiltert und zeigt nur eine begrenzte Anzahl von maximal 200 Suchergebnissen an. 
                  <br/><br/>
                  Bitte wählen Sie mindestens einen Zuwendungsempfänger aus der Suchergebnis-Liste aus. 
                  <br/><br/>
                  Sie können auch mehrere auswählen, indem Sie erneut einen Suchtext eingeben und einen weiteren Empfänger wählen.
                  <br/><br/>
                  Falls Ihr Zuwendungsempfänger noch nicht in MIP-Förderung vorhanden ist, registrieren Sie ihn bitte neu.
              </div>
            </template>
          </ModalWindowButton>
        </div>
        <div style="margin-top: 10px;">
          <MultiSelectAutoCompleter v-if="!mtBody" :minimalSearchStringLength="2" :filter="filter" title="Zuwendungsempf&auml;nger ausw&auml;hlen ..." titleDelete="Zuwendungsempf&auml;nger entfernen"
                      table="V_MASSNAHMETRAEGER" :elemArray="user.__.APPL_PERSON_MASSNAHMETRAEGER" queryParams=":.orderby=NAME,ASC"
                        attributeName="MASSNAHMETRAEGER_NR" :otherField="{'fieldName': 'PERSON_NR', 'value': user.$.NUMMER}"/>
          <span v-if="!!mtBody"> {{mtBody.name}} </span>           
        </div>
      </div> 
      <div class="MIP_AbstandOben-1">
        <input class="checkboxTextsize" type="checkbox" id="registerNewMt" v-model="registerNewMt"/> 
        <label for="registerNewMt">&nbsp;Ich möchte einen neuen Zuwendungsempfänger registrieren.</label>
      </div>
      <div v-if="registerNewMt && !!newMt" class="registerGrid">    
        <label>Name*:</label>
        <FormField :attribute="newMt.$$.NAME"/>
        <label>Zusatz:</label>
        <FormField :attribute="newMt.$$.ADR_ZUSATZ"/>
        <label>Rechtsform*:</label>
        <FormField :attribute="newMt.$$.RECHTSFORM_NR"/>
        <label>Straße*:</label>
        <FormField :attribute="newMt.$$.ADR_STRASSE"/>
        <label>Hausnummer*:</label>
        <FormField :attribute="newMt.$$.ADR_HAUSNUMMER"/>
        <label>Postleitzahl*:</label>
        <FormField :attribute="newMt.$$.ADR_PLZ"/>
        <label>Ort*:</label>
        <FormField :attribute="newMt.$$.ADR_ORT"/>
        <label>Telefonnummer*:</label>
        <FormField :attribute="newMt.$$.ADR_TELEFON_ZENTRALE"/>
        <label>Telefonnummer 2:</label>
        <FormField :attribute="newMt.$$.ADR_TELEFON2"/>
        <label>Vorsteuer abzugsberechtigt:</label>
        <FormField :attribute="newMt.$$.VORSTEUER_ABZUGSBERECHTIGT_JN"/>
        <label>Privatrechtlich organisiert:</label>
        <FormField :attribute="newMt.$$.PRIVATRECHTL_ORGANISIERT_JN"/> 
        <label>Regionalstelle*:</label>
        <AutocompleterLookup :val="regionalstelle()" template="ERKL_REGIONALSTELLE" placeholder="Regionalstelle auswählen ..."/>
      </div>
    </fieldset>   
     
    
    <span style="width:600px;margin-left: 20px;display:block;" class="MIP_AbstandOben-3">
    Wenn Sie auf "Nutzer erstellen" klicken, werden Ihre Angaben in MIP-Förderung hinterlegt.
    Sobald Sie für die Nutzung der Anwendung freigeschaltet sind, werden Sie benachrichtigt.
    Sie können sich anschließend anmelden und ggf. Ihre hinterlegten Daten bearbeiten.
    Insbesondere können Sie Ihren Zugriff dann auch auf bestimmte Zuständigkeitsbereiche einschränken.
    </span>

    <div class="loginToolsRow MIP_AbstandOben">
      <button style="flex-grow: 1" @click="create" class="register-button" >Nutzer erstellen</button>
      <form style="flex-grow: 1" action="login.html">
        <button class="register-button" style="width: 100%" type="submit" value="Abbrechen">Abbrechen</button>
      </form>
    </div>
    
  </div>
</template>
<script>
  import { ref, shallowRef } from "vue";
  import AutocompleterLookup from 'vueforms/src/components/base/AutocompleterLookup.vue';
  import MultiSelectAutoCompleter from "vueforms/src/components/base/MultiSelectAutoCompleter.vue";
  import { fetchXML2Metadata } from "vueforms/src/xmlrdb-metadata/XML2Metadata";
  import FormField from "vueforms/src/components/xmlrdbfield/FormField.vue";
  import windowManager from "vueforms/src/utils/WindowManager";
  import ModalWindowButton from "vueforms/src/components/base/ModalWindowButton.vue";
  import apifetch from "vueforms/src/utils/apifetch";
  import {emptyViewModel} from "vueforms/src/xmlrdb-data/XML2ViewModel";

  export default {
    components:{
      AutocompleterLookup,
      FormField,
      MultiSelectAutoCompleter,
      ModalWindowButton
    },
    emits: ["done"],
    setup(props, { emit }) {      
      const user = shallowRef(null);
      const newMt = shallowRef(null);
      const mtBody = shallowRef(null);
      const regionalstelle = ref(null);
      const passwort = ref(null);
      const passwortRepeat = ref(null);
      const datenschutzerklaerung = ref(false);
      const registerAtExistingMt = ref(false);
      const registerNewMt = ref(false);
      const getUserMeta = async () => {
        const metadata = await fetchXML2Metadata("R2X", "RegisterUser.xml");
        const response = await apifetch("xmlrdb/read/R2X/RegisterUser.xml?~META=3&:.rs.FALSE=1").then(e => e.text());
        user.value = emptyViewModel(response, metadata)._["1"];
      };
      const getMassnahmetraegerMeta = async () => {
        const metadata = await fetchXML2Metadata("R2X", "RegisterMT.xml");
        newMt.value = metadata.getElement("1").newDataElement();
      };
      getUserMeta();
      getMassnahmetraegerMeta();

      const toJackson =(key)=> {
        const parts = key.split(/_(.*)/s);  // Splittet nur am ersten Vorkommen
        let result = parts[0].toLowerCase();
        if (parts.length > 1)
          result += "_" + parts[1]
        return result;
      };

      const copyToLowerCase = (attr) => {
        const target = {};
        for (let key in attr) {
          target[toJackson(key)] = attr[key];
        }
        return target;    
      };

      // Organisationsobjekt erstellen
      const mtCreate = () => {
        if (newMt.value.selfHasError.value) {
          return "Daten nicht korrekt ausgefüllt. Bitte überprüfen Sie die rot markierten Felder. Sie erhalten Hinweise zu den Fehlern, wenn Sie die Maus über die rot markierten Felder bewegen.";
        }
        const body = newMt.value.copyToJackson();
        body.erkl_REGIONALSTELLE = copyToLowerCase(regionalstelle.value);
        body.erkl_RECHTSFORM = {rechtsform_NR: body.rechtsform_NR};
        if (!regionalstelle.value) {
          return "Sie müssen eine Regionalstelle auswählen.";
        }
        if (!body.rechtsform_NR) {
          return "Sie müssen eine Rechtsform auswählen.";
        }
        mtBody.value = body;
        return null;  
      };
      
      // Nutzer registrieren
      const create = async () => {
        if (!registerAtExistingMt.value && !registerNewMt.value) {
          windowManager.message("Bitte wählen Sie einen bereits registrierten Zuwendungsempfänger oder registrieren Sie einen neuen Zuwendungsempfänger.", '<b class="red">Nicht erfolgreich</b>');
          return;
        }
        if (registerNewMt.value) {
          const errorMessage = mtCreate();
          if (errorMessage != null) {
            windowManager.message(errorMessage, '<b class="red">Nicht erfolgreich</b>');
            return;
          }
        }
        if (user.value.selfHasError.value) {
          windowManager.message("Daten nicht korrekt ausgefüllt. Bitte überprüfen Sie die rot markierten Felder. Sie erhalten Hinweise zu den Fehlern, wenn Sie die Maus über die rot markierten Felder bewegen.", '<b class="red">Nicht erfolgreich</b>');
          return;
        }
        if (passwortRepeat.value != passwort.value) {
          windowManager.message("Passwort sowie Passwortbestätigung sind nicht identisch.", '<b class="red">Nicht erfolgreich</b>');
          return;  
        }
        if (!datenschutzerklaerung.value) {
          windowManager.message("Sie müssen eine Einwilligungserklärung zur Erhebung und Verarbeitung von Daten geben.", '<b class="red">Nicht erfolgreich</b>');
          return;  
        }
        const body = user.value.copyToJackson();
        body.passwort = passwort.value;
        body.appl_PERSON_MASSNAHMETRAEGERs = [];
        if (!mtBody.value) {
          for (let i = 0; i < user.value.__.APPL_PERSON_MASSNAHMETRAEGER.dataElements.length; i++) {
            body.appl_PERSON_MASSNAHMETRAEGERs.push({mip_MASSNAHMETRAEGER : {'massnahmetraeger_NR': user.value.__.APPL_PERSON_MASSNAHMETRAEGER.dataElements[i].$.MASSNAHMETRAEGER_NR}});
          }
        }
        else {
          body.appl_PERSON_MASSNAHMETRAEGERs.push({mip_MASSNAHMETRAEGER : mtBody.value});
        }
        const response = apifetch("useraccount/register/user", {
          method: "POST",
          headers: { 'Content-Type': 'application/json'},
          body: JSON.stringify(body)
        }).then(e =>  e.text()).then(data => {
          windowManager.message(data, '<b class="red">Erfolgreich</b>');
          emit('done');
        });
      };

      return {
        regionalstelle : () => regionalstelle,
        user,
        passwort,
        passwortRepeat,
        newMt,
        create,
        datenschutzerklaerung,
        registerAtExistingMt,
        registerNewMt,
        mtBody,
        filter: {
          col: 'AKTIV_JN', op: 'eq', value: 1
        }
      }
    }
  }
</script>

<style lang="scss">
@import "../assets/variables.scss";

body {
  background: none;
}

.red {
  color: $PrimaryRed;
}

.zuwendungsempfaenger {
  display: flex; 
  flex-direction: row; 
  margin-top: 5px; 
  margin-bottom: 5px;
}

</style>